import Footer from '../Components/Footer';
import Header from '../Components/Header';
import New from '../Components/NewsComp/New';

function NewPage() {

    return (
        <div>
            <Header/>
            <New/>
            <Footer/>
        </div>
    );
}

export default NewPage;